import { C34InlineMediaCtaProps } from './C34InlineMediaCta.types';
import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { getDroplink } from 'src/shared/param-utils';
import { INLINE_MEDIA_CTA_CARDS } from '@/shared/static';

export function CreateC34InlineMediaCtaModel(props?: C34InlineMediaCtaProps) {
  const { rendering, params, fields } = props || {};
  const { renderRichText, renderLink, renderText } = useConditionalRendering();
  return {
    headline: renderText(fields?.Headline),
    supportCopy: renderRichText(fields?.SupportCopy),
    bottomSupportCopy: renderRichText(fields?.BottomSupportCopy),
    cta: renderLink(fields?.CTA),
    backgroundColor: getDroplink(params?.BackgroundColor, 'whiteSmoke'),
    contentAlignment: getDroplink(params?.ContentAlignment, 'center'),
    headlineTag: getDroplink(params?.HeadlineTag, 'p'),
    columns: getDroplink(params?.Columns, '2'),
    children: rendering && <Placeholder name={INLINE_MEDIA_CTA_CARDS} rendering={rendering} />,
  };
}
